import React from "react";

// A single menu row: name (+ native name), description, dietary tags and price.
export default function MenuItem({ item }) {
  return (
    <div className="menu-item">
      <div>
        <div className="menu-item-name">
          {item.name}
          {item.native && <span className="native">{item.native}</span>}
        </div>
        <div className="menu-item-desc">{item.desc}</div>
        {item.tags && item.tags.length > 0 && (
          <div className="tags">
            {item.tags.map((tag) => (
              <span className="tag" key={tag}>{tag}</span>
            ))}
          </div>
        )}
      </div>
      <div className="menu-item-price">{item.price}</div>
    </div>
  );
}
